import React, { useEffect, useState, useRef } from "react";
import { Route, Switch, Redirect } from "react-router";
import { useDispatch } from "react-redux";
import * as R from "ramda";

import { useLocation, useHistory } from "react-router-dom";
import { DossiersMain } from "./main";
import { DossiersDetail } from "./detail";
import { LoadingState } from "../../_common/loadingState";

import { fetchUsers } from "../../actions/funecap/dossiers";

import * as Loadings from "../../constants/loadings/funecap/dossiers";

export const Dossiers = ({ partner, etablissement, dossiersReducer, user, teleconseillers, isPartner }) => {
	const dispatch = useDispatch();
	const searchQuery = useLocation();
	const pageQuery = new URLSearchParams(window.location.search);

	let page = pageQuery.get("page");
	let search = pageQuery.get("search");
	let type = pageQuery.get("type");
	let sortBy = pageQuery.get("sortBy");
	let sortDesc = pageQuery.get("sortDesc");
	let creationUser = pageQuery.get("creationUser");
	let status = pageQuery.get("status");
	let fromCreationDate = pageQuery.get("fromCreationDate");
	let toCreationDate = pageQuery.get("toCreationDate");

	page = R.isNil(page) ? 1 : parseInt(page);
	search = R.isNil(search) ? "" : search;
	type = R.isNil(type) ? "" : type;
	sortBy = R.isNil(sortBy) ? "creationDate" : sortBy;
	sortDesc = R.isNil(sortDesc) ? "true" : sortDesc;
	creationUser = R.isNil(creationUser) ? user.id : creationUser;
	status = R.isNil(status) ? "enabled" : status;

	const [pageSearch, setPageSearch] = useState(search);

	const routerQuery = {
		page,
		search,
		type,
		sortBy,
		sortDesc,
		partner,
		creationUser,
		status,
		fromCreationDate,
		toCreationDate,
	};

	useEffect(() => {
		if (isNaN(page) || page === 0) {
			//history.push("/funecap/dossiers");
			return;
		}

		const query = new URLSearchParams(window.location.search);
		const queryCreationUser = query.get("creationUser");
		if (window.location.search == "" && R.isNil(queryCreationUser)) {
			return;
		}
		const queryStatus = query.get("status");
		const queryFromCreationDate = pageQuery.get("fromCreationDate");
		const queryToCreationDate = pageQuery.get("toCreationDate");

		dispatch(fetchUsers("user", page, search, partner.id, type, sortBy, sortDesc, R.isNil(queryCreationUser) ? "" : queryCreationUser, R.isNil(queryStatus) ? "enabled" : queryStatus, R.isNil(queryFromCreationDate) ? "" : queryFromCreationDate, R.isNil(queryToCreationDate) ? "" : queryToCreationDate));
		// eslint-disable-next-line react-hooks/exhaustive-deps

	}, [window.location.search]);

	if (dossiersReducer.isLoading.includes(Loadings.FETCHING_DOSSIERS) && R.isNil(dossiersReducer.items)) {
		return <LoadingState />;
	}

	return (
		<Switch>
			<Route exact path="/funecap/dossiers">
				<DossiersMain dossierState={dossiersReducer} pageSearch={pageSearch} setPageSearch={setPageSearch} partnerState={partner} routerQuery={routerQuery} creationUser={creationUser} pageQuery={pageQuery} teleconseillers={teleconseillers} isPartner={isPartner} userId={user?.id} />
			</Route>
			<Route path="/funecap/dossiers/:user">
				<DossiersDetail dossierState={dossiersReducer} />
			</Route>
			<Route
				render={() => {
					return <Redirect exact to="/funecap/dossiers" />;
				}}
			/>
		</Switch>
	);
};
